import React from 'react';
import { Link, NavLink } from 'react-router';



import { FaBars } from "react-icons/fa";

import pages from "./data/pages";

const Header = () => {

    const NavbarCollapse = () => {
        document.getElementById("navbar-menu").classList.toggle("collapsed");
    }

  return (
    <>
    <nav id="navbar" className="expanded">
        <div className='logo-container'>
            <a  href="/">
                <img className="logo" src="/images/logo-transparent.png"/>
            </a>
        </div>
        <div className="hamburger-container">
            <span  onClick={NavbarCollapse}>
                <FaBars />
            </span>
            
        </div>
        <div className="menu-container">
            <ul id="navbar-menu" className="navbar-menu collapsed" onClick={() => {document.getElementById("navbar-menu").classList.add("collapsed");}}>
                {pages.map((page) => (
                    <li key={page.id} >
                        <NavLink to={`/${page.pageId}`}>{page.pageName}</NavLink>
                    </li>
                ))}
            </ul>
        </div>
    </nav>
    <div className="navbar-background"></div>
    </>
  )
}

export default Header